module.exports = __webpack_public_path__ + "static/media/sanjay.ba52107e.jpg";